import { LandingApp } from '@juvare/common-web-ui/LandingApp';
import { getAppManifest } from '@juvare/platform-sdk-react/ui/stores';
import { getLoginUrl } from '@juvare/platform-sdk-react/ui/utils';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from './hooks';

export const AnonymousApp: React.FC = () => {
    const { t } = useTranslation();
    const appManifest = useSelector(getAppManifest);
    return (
        <LandingApp
            appTitle={t('appTitle')}
            loginTitle={t('loginTitle')}
            loginHtmlContent=''
            oktaLoginFormProps={{
                oktaUrl: appManifest.oktaUrl,
                onLogin: () => window.location.assign(getLoginUrl()),
            }}
            pages={[]}
        />
    );
};
